import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.index-of";
import _toConsumableArray from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.assign";
import { __rest } from "tslib";
import stringify from 'fast-json-stable-stringify';
import { isObject, isString } from 'vega-util';
import { dateTimeExprToExpr } from './datetime';
import * as log from './log';
import { accessPathWithDatum, keys, replaceAll, varName } from './util';
export var TimeUnit;

(function (TimeUnit) {
  TimeUnit.YEAR = 'year';
  TimeUnit.MONTH = 'month';
  TimeUnit.DAY = 'day';
  TimeUnit.DATE = 'date';
  TimeUnit.HOURS = 'hours';
  TimeUnit.MINUTES = 'minutes';
  TimeUnit.SECONDS = 'seconds';
  TimeUnit.MILLISECONDS = 'milliseconds';
  TimeUnit.YEARMONTH = 'yearmonth';
  TimeUnit.YEARMONTHDATE = 'yearmonthdate';
  TimeUnit.YEARMONTHDATEHOURS = 'yearmonthdatehours';
  TimeUnit.YEARMONTHDATEHOURSMINUTES = 'yearmonthdatehoursminutes';
  TimeUnit.YEARMONTHDATEHOURSMINUTESSECONDS = 'yearmonthdatehoursminutesseconds'; // MONTHDATE and MONTHDATEHOURS always include 29 February since we use year 0th (which is a leap year);

  TimeUnit.MONTHDATE = 'monthdate';
  TimeUnit.MONTHDATEHOURS = 'monthdatehours';
  TimeUnit.HOURSMINUTES = 'hoursminutes';
  TimeUnit.HOURSMINUTESSECONDS = 'hoursminutesseconds';
  TimeUnit.MINUTESSECONDS = 'minutesseconds';
  TimeUnit.SECONDSMILLISECONDS = 'secondsmilliseconds';
  TimeUnit.QUARTER = 'quarter';
  TimeUnit.YEARQUARTER = 'yearquarter';
  TimeUnit.QUARTERMONTH = 'quartermonth';
  TimeUnit.YEARQUARTERMONTH = 'yearquartermonth';
  TimeUnit.UTCYEAR = 'utcyear';
  TimeUnit.UTCMONTH = 'utcmonth';
  TimeUnit.UTCDAY = 'utcday';
  TimeUnit.UTCDATE = 'utcdate';
  TimeUnit.UTCHOURS = 'utchours';
  TimeUnit.UTCMINUTES = 'utcminutes';
  TimeUnit.UTCSECONDS = 'utcseconds';
  TimeUnit.UTCMILLISECONDS = 'utcmilliseconds';
  TimeUnit.UTCYEARMONTH = 'utcyearmonth';
  TimeUnit.UTCYEARMONTHDATE = 'utcyearmonthdate';
  TimeUnit.UTCYEARMONTHDATEHOURS = 'utcyearmonthdatehours';
  TimeUnit.UTCYEARMONTHDATEHOURSMINUTES = 'utcyearmonthdatehoursminutes';
  TimeUnit.UTCYEARMONTHDATEHOURSMINUTESSECONDS = 'utcyearmonthdatehoursminutesseconds'; // UTCMONTHDATE and UTCMONTHDATEHOURS always include 29 February since we use year 0th (which is a leap year);

  TimeUnit.UTCMONTHDATE = 'utcmonthdate';
  TimeUnit.UTCMONTHDATEHOURS = 'utcmonthdatehours';
  TimeUnit.UTCHOURSMINUTES = 'utchoursminutes';
  TimeUnit.UTCHOURSMINUTESSECONDS = 'utchoursminutesseconds';
  TimeUnit.UTCMINUTESSECONDS = 'utcminutesseconds';
  TimeUnit.UTCSECONDSMILLISECONDS = 'utcsecondsmilliseconds';
  TimeUnit.UTCQUARTER = 'utcquarter';
  TimeUnit.UTCYEARQUARTER = 'utcyearquarter';
  TimeUnit.UTCQUARTERMONTH = 'utcquartermonth';
  TimeUnit.UTCYEARQUARTERMONTH = 'utcyearquartermonth';
})(TimeUnit || (TimeUnit = {}));
/** Time Unit that only corresponds to only one part of Date objects. */


var LOCAL_SINGLE_TIMEUNIT_INDEX = {
  year: 1,
  quarter: 1,
  month: 1,
  day: 1,
  date: 1,
  hours: 1,
  minutes: 1,
  seconds: 1,
  milliseconds: 1
};
export var TIMEUNIT_PARTS = keys(LOCAL_SINGLE_TIMEUNIT_INDEX);
export function isLocalSingleTimeUnit(timeUnit) {
  return !!LOCAL_SINGLE_TIMEUNIT_INDEX[timeUnit];
}
var UTC_SINGLE_TIMEUNIT_INDEX = {
  utcyear: 1,
  utcquarter: 1,
  utcmonth: 1,
  utcday: 1,
  utcdate: 1,
  utchours: 1,
  utcminutes: 1,
  utcseconds: 1,
  utcmilliseconds: 1
};
export function isUtcSingleTimeUnit(timeUnit) {
  return !!UTC_SINGLE_TIMEUNIT_INDEX[timeUnit];
}
var LOCAL_MULTI_TIMEUNIT_INDEX = {
  yearquarter: 1,
  yearquartermonth: 1,
  yearmonth: 1,
  yearmonthdate: 1,
  yearmonthdatehours: 1,
  yearmonthdatehoursminutes: 1,
  yearmonthdatehoursminutesseconds: 1,
  quartermonth: 1,
  monthdate: 1,
  monthdatehours: 1,
  hoursminutes: 1,
  hoursminutesseconds: 1,
  minutesseconds: 1,
  secondsmilliseconds: 1
};
var UTC_MULTI_TIMEUNIT_INDEX = {
  utcyearquarter: 1,
  utcyearquartermonth: 1,
  utcyearmonth: 1,
  utcyearmonthdate: 1,
  utcyearmonthdatehours: 1,
  utcyearmonthdatehoursminutes: 1,
  utcyearmonthdatehoursminutesseconds: 1,
  utcquartermonth: 1,
  utcmonthdate: 1,
  utcmonthdatehours: 1,
  utchoursminutes: 1,
  utchoursminutesseconds: 1,
  utcminutesseconds: 1,
  utcsecondsmilliseconds: 1
};
var UTC_TIMEUNIT_INDEX = Object.assign(Object.assign({}, UTC_SINGLE_TIMEUNIT_INDEX), UTC_MULTI_TIMEUNIT_INDEX);
export function isUTCTimeUnit(t) {
  return !!UTC_TIMEUNIT_INDEX[t];
}
export function getLocalTimeUnit(t) {
  return t.substr(3);
}
var TIMEUNIT_INDEX = Object.assign(Object.assign(Object.assign(Object.assign({}, LOCAL_SINGLE_TIMEUNIT_INDEX), UTC_SINGLE_TIMEUNIT_INDEX), LOCAL_MULTI_TIMEUNIT_INDEX), UTC_MULTI_TIMEUNIT_INDEX);
export var TIMEUNITS = keys(TIMEUNIT_INDEX); // In order of increasing specificity

export var VEGALITE_TIMEFORMAT = {
  'year-month': '%b %Y ',
  'year-month-date': '%b %d, %Y '
};
export function isTimeUnit(t) {
  return !!TIMEUNIT_INDEX[t];
}
export function getTimeUnitParts(timeUnit) {
  return TIMEUNIT_PARTS.reduce(function (parts, part) {
    if (containsTimeUnit(timeUnit, part)) {
      return [].concat(_toConsumableArray(parts), [part]);
    }

    return parts;
  }, []);
}
/** Returns true if fullTimeUnit contains the timeUnit, false otherwise. */

export function containsTimeUnit(fullTimeUnit, timeUnit) {
  var index = fullTimeUnit.indexOf(timeUnit);
  return index > -1 && (timeUnit !== TimeUnit.SECONDS || index === 0 || fullTimeUnit.charAt(index - 1) !== 'i') // exclude milliseconds
  ;
}
/**
 * Returns Vega expresssion for a given timeUnit and fieldRef
 */

export function fieldExpr(fullTimeUnit, field) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    end: false
  },
      end = _ref.end;

  var fieldRef = accessPathWithDatum(field);
  var utc = isUTCTimeUnit(fullTimeUnit) ? 'utc' : '';

  function func(timeUnit) {
    if (timeUnit === TimeUnit.QUARTER) {
      // quarter starting at 0 (0,3,6,9).
      return "(".concat(utc, "quarter(").concat(fieldRef, ")-1)");
    } else {
      return "".concat(utc).concat(timeUnit, "(").concat(fieldRef, ")");
    }
  }

  var lastTimeUnit;
  var d = TIMEUNIT_PARTS.reduce(function (dateExpr, tu) {
    if (containsTimeUnit(fullTimeUnit, tu)) {
      dateExpr[tu] = func(tu);
      lastTimeUnit = tu;
    }

    return dateExpr;
  }, {});

  if (end) {
    d[lastTimeUnit] += '+1';
  }

  return dateTimeExprToExpr(d);
}
export function getTimeUnitSpecifierExpression(timeUnit) {
  if (!timeUnit) {
    return undefined;
  }

  var timeUnitParts = getTimeUnitParts(timeUnit);
  return "timeUnitSpecifier(".concat(stringify(timeUnitParts), ", ").concat(stringify(VEGALITE_TIMEFORMAT), ")");
}
/**
 * returns the signal expression used for axis labels for a time unit
 */

export function formatExpression(timeUnit, field, isUTCScale) {
  if (!timeUnit) {
    return undefined;
  }

  var timeUnitSpecifierExpr = getTimeUnitSpecifierExpression(timeUnit); // We only use utcFormat for utc scale
  // For utc time units, the data is already converted as a part of timeUnit transform.
  // Thus, utc time units should use timeFormat to avoid shifting the time twice.

  if (isUTCScale || isUTCTimeUnit(timeUnit)) {
    return "utcFormat(".concat(field, ", ").concat(timeUnitSpecifierExpr, ")");
  } else {
    return "timeFormat(".concat(field, ", ").concat(timeUnitSpecifierExpr, ")");
  }
}
export function normalizeTimeUnit(timeUnit) {
  if (!timeUnit) {
    return undefined;
  }

  var params;

  if (isString(timeUnit)) {
    params = {
      unit: correctTimeUnit(timeUnit)
    };
  } else if (isObject(timeUnit)) {
    params = Object.assign(Object.assign({}, timeUnit), timeUnit.unit ? {
      unit: correctTimeUnit(timeUnit.unit)
    } : {});
  }

  if (isUTCTimeUnit(params.unit)) {
    params.utc = true;
    params.unit = getLocalTimeUnit(params.unit);
  }

  return params;
}
export function correctTimeUnit(timeUnit) {
  if (timeUnit !== 'day' && timeUnit.indexOf('day') >= 0) {
    log.warn(log.message.dayReplacedWithDate(timeUnit));
    return replaceAll(timeUnit, 'day', 'date');
  }

  return timeUnit;
}
export function timeUnitToString(tu) {
  var _a = normalizeTimeUnit(tu),
      utc = _a.utc,
      rest = __rest(_a, ["utc"]);

  if (rest.unit) {
    return (utc ? 'utc' : '') + keys(rest).map(function (p) {
      return varName("".concat(p === 'unit' ? '' : "_".concat(p, "_")).concat(rest[p]));
    }).join('');
  } else {
    // when maxbins is specified instead of units
    return (utc ? 'utc' : '') + 'timeunit' + keys(rest).map(function (p) {
      return varName("_".concat(p, "_").concat(rest[p]));
    }).join('');
  }
}